import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import Timeline from "astrid-components/lib/components/Audio/Timeline";
import artifactMarkerTypes from "astrid-firestore/src/api/artifacts/constants/artifactMarkerTypes";
import useTemp from "astrid-hooks/src/useTemp";

export default function ArtifactAudioPlayerTimelineMarker({ marker, disabled, onChange }) {
	const { t } = useTranslation();
	const [position, setPosition] = useTemp(marker.position);

	const onMove = useCallback(
		(position) => {
			setPosition(position > 2000 ? position : 0);
		},
		[setPosition],
	);
	return (
		<Timeline.Marker
			active
			color={marker.safe ? marker.color : "negative"}
			position={position}
			onMove={!disabled && marker.type === artifactMarkerTypes.CHAPTER ? onMove : undefined}
			// onClick={onClick}
			onChange={!disabled && (() => onChange(position))}
		>
			{marker.text} {!marker.safe && `(${t("unsafe", "Unsafe")})`}
		</Timeline.Marker>
	);
}
